import { render, staticRenderFns } from "./donut-chart.vue?vue&type=template&id=28de7146&scoped=true&"
import script from "./donut-chart.vue?vue&type=script&lang=js&"
export * from "./donut-chart.vue?vue&type=script&lang=js&"
import style0 from "./donut-chart.vue?vue&type=style&index=0&id=28de7146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de7146",
  null
  
)

export default component.exports